import PropTypes from 'prop-types';
import { Button, Dropdown } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { CustomIcon } from '$src/components/CustomIcon';
import UserIcon from './UserIcon';

import './index.less';

function UserArea({ user, onLogout }) {
  return (
    <Dropdown
      trigger={['click']}
      overlay={
        <div className="user-dropdown" data-testid="user-dropdown">
          <div className="user-dropdown__ctrl user-dropdown__ctrl_logout">
            <Button className="user-dropdown__logout" onClick={onLogout} type="link" data-testid="logout-button">
              <CustomIcon className="user-dropdown__logout-icon" type="regular" name="icon-logout.svg" /> Logout
            </Button>
          </div>
        </div>
      }
    >
      <div className="user-dropdown-username">
        <UserIcon user={user} />
        <DownOutlined className="user-dropdown-username__icon" />
      </div>
    </Dropdown>
  );
}

UserArea.propTypes = {
  opened: PropTypes.bool,
  user: PropTypes.shape({
    user_id: PropTypes.number,
  }),
  onLogout: PropTypes.func.isRequired,
};

export default UserArea;
